export interface FactSource {
  readonly url: string
  readonly title: string
}

export type FactBasis = 'extracted' | 'edited' | 'empty'

export const FACT_BASES: readonly FactBasis[] = ['extracted', 'edited', 'empty']

export function isFactEdited(fact: { readonly basis: FactBasis }): boolean {
  return fact.basis === 'edited'
}
